import {
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Loading,
  MaskedInput,
  IconButton,
  Button,
  TextField,
} from "../../../../../components";
import { useEffect, useState } from "react";
import {
  notification,
  AdzapService,
  MensagemPersonalizadaService,
  SessionService,
  OrcamentoServicosService,
} from "../../../../../services";
import { responseErros, voltar } from "../../../../../utils";

const adzapService = new AdzapService();
const mensagemPersonalizadaService = new MensagemPersonalizadaService();
const sessionService = new SessionService();
const orcamentoServicoService = new OrcamentoServicosService();

const EnvioWhatsappOrcamentoDialog = ({ open, setOpen, data, initialCollapses }) => {
  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState("");
  const [nomeCompletoCliente, setNomeCompletoCliente] = useState("");
  const [erroCelular, setErroCelular] = useState(false);
  const empresaUsuario = sessionService.getEmpresaAndUsuario();

  useEffect(() => {
    if (open && data?.cliente?.id) {
      setCelular(data?.cliente?.celular);
      setNomeCompletoCliente(data?.cliente?.nomeRazaoSocial);
    }
  }, [open]);

  const handleInputChange = (event) => {
    setErroCelular(false);
    setCelular(event.target.value);
  };

  function handleCloseDialog() {
    setLoading(false);
    setCelular("");
    setOpen(false);
    if (initialCollapses) initialCollapses();
    voltar();
  }

  async function handleSubmit() {
    if (!celular || celular.replace(/\D/g, "").length < 11) {
      notification.erroGenericos("Informe um número de celular válido");
      setErroCelular(true);
      return;
    }
    setLoading(true);
    const result = await orcamentoServicoService.getOS(data?.id, data?.dto);
    setLoading(false);
    if (!result.isAxiosError) {
      await enviarPdf({ file: result.data, docName: `ORC_Nº${data?.numeroDocumento}` });
    } else {
      responseErros(result);
    }
  }

  async function enviarPdf(dadosArquivo) {
    try {
      const nomeCliente = data?.cliente?.nomeRazaoSocial || nomeCompletoCliente;
      const getPrimeiroNome = (nome) => nome?.split(" ")[0] || "";
      let text = "Segue Orçamento de Serviço solicitado!";

      const texto = await mensagemPersonalizadaService.getMensagem({
        contexto: "orcamento-servico",
        apelidoFantasia: data?.empresa?.nome,
        nomeCompletoCliente: nomeCliente,
        primeiroNomeCliente: getPrimeiroNome(nomeCliente),
        nomeUsuario: empresaUsuario.usuario?.nome,
      });

      if (!texto.isAxiosError) {
        text = texto.data;
      }

      const result = await adzapService.enviarMensagem({
        number: celular,
        type: "document",
        file: dadosArquivo.file,
        docName: dadosArquivo.docName,
        text,
      });

      if (!result.isAxiosError) {
        handleCloseDialog();
        notification.sucessoGenericos("Documento enviado com sucesso!");
      } else {
        handleCloseDialog();
        responseErros(result);
      }
    } catch {
      notification.erroGenericos("Falha no envio do documento");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={handleCloseDialog}>
      <CardHeader title="Envio Whatsapp" className="m-2" />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="nomeCompletoCliente"
              name="nomeCompletoCliente"
              label="Nome"
              variant="outlined"
              fullWidth
              value={nomeCompletoCliente}
              onChange={(e) => setNomeCompletoCliente(e.target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton disabled>
                    <i className="ph-fill ph-user" style={{ fontSize: 20 }}></i>
                  </IconButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MaskedInput
              id="celular"
              name="celular"
              label="Celular"
              mask="(99) 9 9999-9999"
              onChange={handleInputChange}
              margin="none"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                endAdornment: (
                  <IconButton disabled>
                    <i className="ph-fill ph-device-mobile" style={{ fontSize: 20 }}></i>
                  </IconButton>
                ),
              }}
              error={erroCelular}
              value={celular || ""}
            />
          </Grid>
          <Grid item xs={12}>
            <Button fullWidth variant="contained" color="primary" onClick={handleSubmit}>
              Enviar Documento
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <Loading loading={loading} />
    </Dialog>
  );
};

export default EnvioWhatsappOrcamentoDialog;
